import { CheckCircle2, Clock, XCircle, AlertCircle } from "lucide-react";

// ─── Design tokens (3. Taraf / TPRM theme) ───────────────────────────────────

export const border = {
  card: "0.5px solid #d1d5db",
};

export const typography = {
  pageTitle:  { fontSize: "1.25rem", fontWeight: 700 },
  modalTitle: { fontSize: "1rem",    fontWeight: 700 },
  subtitle:   { fontSize: "0.78rem", fontWeight: 400 },
  section:    { fontSize: "0.85rem", fontWeight: 600 },
  statValue:  { fontSize: "1.8rem",  fontWeight: 600, lineHeight: 1.1 },
  statLabel:  { fontSize: "0.72rem", fontWeight: 500 },
  statSub:    { fontSize: "0.68rem" },
  body:       { fontSize: "0.83rem", fontWeight: 400 },
  bodyMedium: { fontSize: "0.83rem", fontWeight: 500 },
  bodyBold:   { fontSize: "0.83rem", fontWeight: 600 },
  label:      { fontSize: "0.82rem", fontWeight: 600 },
  badge:      { fontSize: "0.72rem", fontWeight: 600 },
  meta:       { fontSize: "0.7rem",  fontWeight: 500 },
  tiny:       { fontSize: "0.68rem" },
  nav:        { fontSize: "0.8125rem", fontWeight: 500 },
  tabLabel:   { fontSize: "0.8125rem", fontWeight: 500 },
  tabLabelActive: { fontSize: "0.8125rem", fontWeight: 500 },
};

export const riskCfg = {
  Critical: { bg: "bg-red-50",    text: "text-red-600",    border: "border-red-200",    dot: "bg-red-500",    fill: "#ef4444" },
  High:     { bg: "bg-orange-50", text: "text-orange-600", border: "border-orange-200", dot: "bg-orange-500", fill: "#f97316" },
  Medium:   { bg: "bg-yellow-50", text: "text-yellow-700", border: "border-yellow-200", dot: "bg-yellow-500", fill: "#eab308" },
  Low:      { bg: "bg-green-50",  text: "text-green-700",  border: "border-green-200",  dot: "bg-green-500",  fill: "#22c55e" },
};

export const statusCfg = {
  Completed:     { icon: CheckCircle2, color: "text-emerald-600" },
  "In Progress": { icon: Clock,        color: "text-blue-500"    },
  Overdue:       { icon: XCircle,      color: "text-red-500"     },
  Pending:       { icon: AlertCircle,  color: "text-gray-400"    },
};

export const scoreBarColor = {
  Critical: "bg-red-500",
  High:     "bg-orange-500",
  Medium:   "bg-yellow-500",
  Low:      "bg-green-500",
};

export const riskBarColors = {
  Critical: "#dc2626",
  High:     "#f97316",
  Medium:   "#3b82f6",
  Low:      "#10b981",
};

/** Numeric risk score badge (1–16+ scale used in risk table). */
export function getRiskScoreClasses(value) {
  const v = Number(value) || 0;
  if (v <= 2) return "bg-emerald-500 text-white";
  if (v <= 6) return "bg-blue-500 text-white";
  if (v <= 12) return "bg-orange-500 text-white";
  return "bg-red-500 text-white";
}

// ─── App shell / navigation ──────────────────────────────────────────────────
export const shell = {
  headerHeight: "h-16",
  railWidth:    "w-16",
  bg:           "bg-white",
  surface:      "bg-gray-50",
  border:       "border-gray-200",
  activeBg:     "bg-blue-50",
  activeText:   "text-blue-600",
  idleText:     "text-gray-500",
  hoverBg:      "hover:bg-gray-50",
  indicator:    "bg-blue-600",
  /** Secondary module sidebar (Controls, Audit, TPRM, …) */
  moduleSidebar: {
    title: { fontSize: "17px", fontWeight: 600, color: "#2C2C2C", lineHeight: 1.25 },
    item: { fontSize: "13px" },
  },
  /** Keep nav below modals/overlays (modal uses zIndex.modal). */
  zIndex: {
    nav: 10,
    navDropdown: 40,
    sidebarMobile: 50,
    modal: 100,
    toast: 110,
  },
};
